import { OverlayRef } from '@angular/cdk/overlay';
import { IBbitCalendarEvent } from '@bbitgmbh/bbit.utils';
import { DateTime } from 'luxon';
import { Observable, Subject } from 'rxjs';
import { IBbitBookingOption } from '../booking.service';
import { BookingOverlayService } from '../booking-overlay.service';

export interface IBbitBookingOverlayData {
  event: IBbitCalendarEvent;
  option: IBbitBookingOption;
  events: IBbitCalendarEvent[];
  closingTime: DateTime;
}

export class BookingOverlayRef {
  private _onClose = new Subject<boolean>();

  constructor(
    private _overlayRef: OverlayRef,
    private _data: IBbitBookingOverlayData,
    public service: BookingOverlayService,
  ) {}

  public close(reload = false): void {
    this._overlayRef.dispose();
    this._onClose.next(reload);
    this._onClose.complete();
  }

  public getData(): IBbitBookingOverlayData {
    return this._data;
  }

  public observeClose(): Observable<boolean> {
    return this._onClose.asObservable();
  }
}
